import {ContentfulClient} from "react-contentful";

export const contentfulClient = new ContentfulClient({
    accessToken: process.env.CONTENTFUL_ACCESS_TOKEN || "u716LdH-DwmS6WZLuMDnKDap_-jX0c-4wApZnTTHXe4",
    space: process.env.CONTENTFUL_SPACE_ID || "tzyjn3z7mm9b",
    environment: process.env.CONTENTFUL_ENVIRONMENT || "staging"
});